"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Defaults = {
    configId: "default"
};
exports.Defaults = Defaults;
/*
 * A configuration interceptor type router that performs configuration based on a configured
 * configuration id which can be overridden by a _configId request parameter.
 * An instance of ConfigRouter is typically placed early in your app/router configuration (as just about everything else depends on configuration)
 */
var ConfigRouter = /** @class */ (function () {
    function ConfigRouter(opts) {
        this._env = opts.env || {};
        this._configMap = opts.configMap;
    }
    ConfigRouter.prototype.handleRequest = function (req, next) {
        var configId = req.params["_configId"] || this._env.configId || this._env.configName;
        if (!configId) {
            configId = Defaults.configId;
        }
        if (configId !== this._currentConfigId) {
            this._currentConfigId = configId;
            // find the appropriate configurer
            var config = this._configMap[configId];
            if (!config) {
                return Promise.reject({ code: "NOT_FOUND", message: "Unable to find configuration: " + configId });
            }
            return config(Object.assign({}, this._env)).then(next);
        }
        return next();
    };
    return ConfigRouter;
}());
exports.ConfigRouter = ConfigRouter;
